module.exports = __webpack_public_path__ + "static/img/sc5.943a479.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc5.png
// module id = T0ir
// module chunks = 25